export const DEFAULT_PLAN_PRODUCT_LIMITS = {
  growth: 5_000,
  scale: 20_000,
  solo: 500,
  starter: 1_000,
};

export class ProductLimitError extends Error {
  constructor({ currentCount, limit, planId, planName }) {
    super(`Your ${planName} plan supports up to ${limit.toLocaleString()} active products.`);
    this.name = "ProductLimitError";
    this.code = "PRODUCT_LIMIT_REACHED";
    this.currentCount = currentCount;
    this.limit = limit;
    this.planId = planId;
    this.planName = planName;
  }
}

export function getProductLimit(session) {
  const configuredLimit = Number(session?.subscription?.plan?.maxProducts);
  if (Number.isFinite(configuredLimit) && configuredLimit > 0) {
    return configuredLimit;
  }

  const planId = String(session?.subscription?.plan?.id || "").trim().toLowerCase();
  return DEFAULT_PLAN_PRODUCT_LIMITS[planId] ?? 10_000;
}

export function isProductLimitError(error) {
  return error instanceof ProductLimitError || error?.code === "PRODUCT_LIMIT_REACHED";
}
